import { render, staticRenderFns } from "./AddMultipleChoiceAnswerResource.vue?vue&type=template&id=03c90716&"
import script from "./AddMultipleChoiceAnswerResource.vue?vue&type=script&lang=js&"
export * from "./AddMultipleChoiceAnswerResource.vue?vue&type=script&lang=js&"
import style0 from "./AddMultipleChoiceAnswerResource.vue?vue&type=style&index=0&id=03c90716&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports